import api from "@/plugins/api/EntryPoint";

export default {
  getFeedback(callBackFn) {
    api.get(`feedback/get-all-feedback-new`, callBackFn);
  },
  createTicket(ticket, callBackFn) {
    return api.post(`feedback/add-new-feedback-new`, ticket, callBackFn);
  },
};
